// @flow
import Icon from './Icon';

export default Icon;
export type { IconNameType } from './Icon';
